import * as types from './types'

export default {
  [types.SET_STEP]: function(state, { step }) {
    state.step = step
  },
  [types.SET_TYPE]: function(state, { type }) {
    state.chosenType = type.toString()
  },
  [types.SET_GRANULARITY]: function(state, payload) {
    state.monthRecurrence = payload.monthRecurrence.toString() || '1'
  },
  [types.SET_THIRD_PARTY_ALREADY_SETUP]: function(state, alreadySetup) {
    state.thirdPartyAlreadySetup = alreadySetup
  },
  [types.SET_GLOBAL_INFORMATIONS]: function(state, payload) {
    state.globalInformations.firstname = payload.firstname
    state.globalInformations.lastname = payload.lastname
    state.globalInformations.email = payload.email
    state.globalInformations.password = payload.password || ''
    state.globalInformations.phone = payload.phone || ''
    state.globalInformations.newsletter = payload.newsletter || false

    state.globalInformations.sex = payload.sex
    state.globalInformations.birthday = payload.birthday
    state.globalInformations.knowledgeWine = payload.knowledgeWine
    state.isLogged = payload.isLogged || false
    state.userId = payload.userId || null
  },
  [types.SET_SHIPPING_INFORMATIONS]: function(state, payload) {
    state.shippingInformations.shipping.address = payload.shippingAddress
    state.shippingInformations.shipping.complement = payload.shippingComplement
    state.shippingInformations.shipping.postalCode = payload.shippingPostalCode
    state.shippingInformations.shipping.city = payload.shippingCity
    state.shippingInformations.shipping.enterprise = payload.shippingEnterprise
    state.shippingInformations.shipping.fixNumber = payload.shippingFixNumber
    state.shippingInformations.shipping.mobileNumber = payload.shippingMobileNumber

    state.shippingInformations.billing.address = payload.billingAddress
    state.shippingInformations.billing.complement = payload.billingComplement
    state.shippingInformations.billing.postalCode = payload.billingPostalCode
    state.shippingInformations.billing.city = payload.billingCity

    state.shippingInformations.billing.enterprise = payload.billingEnterprise
    state.shippingInformations.billing.fixNumber = payload.billingFixNumber
    state.shippingInformations.billing.mobileNumber = payload.billingMobileNumber
  },
  [types.SET_PAYMENT_INFORMATIONS]: function(state, payload) {
    state.paymentInformations.creditCardNumber = payload.creditCardNumber
    state.paymentInformations.monthValidation = payload.monthValidation
    state.paymentInformations.yearValidation = payload.yearValidation
    state.paymentInformations.validationCode = payload.validationCode
  },
  [types.RESET_SUBSCRIPTION]: function(state) {
    state.step = 1
    state.chosenType = null
    state.monthRecurrence = null
    state.isLogged = false
    state.userId = null
    state.globalInformations.firstname = ''
    state.globalInformations.lastname = ''
    state.globalInformations.phone = ''

    state.shippingInformations.shipping.address = ''
    state.shippingInformations.shipping.complement = ''
    state.shippingInformations.shipping.postalCode = ''
    state.shippingInformations.shipping.city = ''
    state.shippingInformations.shipping.enterprise = ''
    state.shippingInformations.shipping.fixNumber = ''
    state.shippingInformations.shipping.mobileNumber = ''

    state.shippingInformations.billing.address = ''
    state.shippingInformations.billing.complement = ''
    state.shippingInformations.billing.postalCode = ''
    state.shippingInformations.billing.city = ''
    state.shippingInformations.billing.enterprise = ''
    state.shippingInformations.billing.fixNumber = ''
    state.shippingInformations.billing.mobileNumber = ''

    state.paymentInformations.creditCardNumber = ''
    state.paymentInformations.monthValidation = ''
    state.paymentInformations.yearValidation = ''
    state.paymentInformations.validationCode = ''
    state.paymentInformations.validationCode = ''
  }
}
